var map = {
	"./academic_painting.webp": 8860,
	"./academic_painting_fake.webp": 4601,
	"./amazing_painting.webp": 8003,
	"./amazing_painting_fake.webp": 4993,
	"./ancient_statue.webp": 4308,
	"./ancient_statue_fake.webp": 7458,
	"./basic_painting.webp": 7855,
	"./basic_painting_fake.webp": 5014,
	"./beautiful_statue.webp": 5407,
	"./beautiful_statue_fake.webp": 7893,
	"./calm_painting.webp": 1258,
	"./common_painting.webp": 1556,
	"./detailed_painting.webp": 537,
	"./detailed_painting_fake.webp": 779,
	"./dynamic_painting.webp": 1469,
	"./familiar_statue.webp": 4769,
	"./famous_painting.webp": 2213,
	"./famous_painting_fake.webp": 6189,
	"./flowery_painting.webp": 4132,
	"./gallant_statue.webp": 3471,
	"./gallant_statue_fake.webp": 1112,
	"./glowing_painting.webp": 767,
	"./graceful_painting.webp": 1486,
	"./graceful_painting_fake.webp": 9177,
	"./great_statue.webp": 58,
	"./informative_statue.webp": 9953,
	"./informative_statue_fake.webp": 5816,
	"./jolly_painting.webp": 1967,
	"./jolly_painting_fake.webp": 8729,
	"./moody_painting.webp": 5097,
	"./motherly_statue.webp": 8090,
	"./motherly_statue_fake.webp": 9934,
	"./moving_painting.webp": 2395,
	"./moving_painting_fake.webp": 7608,
	"./mysterious_painting.webp": 4096,
	"./mystic_statue.webp": 1808,
	"./mystic_statue_fake.webp": 4322,
	"./nice_painting.webp": 6896,
	"./perfect_painting.webp": 4752,
	"./proper_painting.webp": 1423,
	"./quaint_painting.webp": 8792,
	"./quaint_painting_fake.webp": 4413,
	"./robust_statue.webp": 146,
	"./robust_statue_fake.webp": 2653,
	"./rock_head_statue.webp": 7265,
	"./rock_head_statue_fake.webp": 4578,
	"./scary_painting.webp": 9774,
	"./scary_painting_fake.webp": 4975,
	"./scenic_painting.webp": 1266,
	"./scenic_painting_fake.webp": 457,
	"./serene_painting.webp": 3971,
	"./serene_painting_fake.webp": 8440,
	"./sinking_painting.webp": 3894,
	"./solemn_painting.webp": 1998,
	"./solemn_painting_fake.webp": 1591,
	"./tremendous_statue.webp": 5803,
	"./tremendous_statue_fake.webp": 356,
	"./twinkling_painting.webp": 8867,
	"./valiant_statue.webp": 5550,
	"./valiant_statue_fake.webp": 7907,
	"./warm_painting.webp": 1171,
	"./warrior_statue.webp": 2389,
	"./warrior_statue_fake.webp": 6261,
	"./wild_painting_left_half.webp": 873,
	"./wild_painting_left_half_fake.webp": 4124,
	"./wild_painting_right_half.webp": 3508,
	"./wild_painting_right_half_fake.webp": 9358,
	"./wistful_painting.webp": 3943,
	"./wistful_painting_fake.webp": 4829,
	"./worthy_painting.webp": 7114
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8189;